import { MotorCoverType } from 'scenes/motor/types';

export enum Included {
  Yes,
  No,
  Optional,
}

export type KeyDifferenceItem = {
  included: Included;
  additionalText?: string;
};

export type KeyDifference = {
  label: string;
  items: [KeyDifferenceItem, KeyDifferenceItem];
};

export type KeyDifferences = {
  headers: [MotorCoverType, MotorCoverType];
  differences: KeyDifference[];
};

export const thirdPartyKeyDifferences: KeyDifferences = {
  headers: [
    MotorCoverType.ThirdPartyPropertyDamage,
    MotorCoverType.ThirdPartyFireAndTheft,
  ],
  differences: [
    {
      label: 'Stolen car',
      items: [{ included: Included.No }, { included: Included.Yes }],
    },
    {
      label: 'Fire and explosion damage',
      items: [{ included: Included.No }, { included: Included.Yes }],
    },
    {
      label: 'Damage caused by uninsured drivers',
      items: [
        { included: Included.Yes, additionalText: 'Up to $3,000' },
        {
          included: Included.Yes,
          additionalText: 'Up to $3,000',
        },
      ],
    },
    {
      label: "Damage to someone else's car or property",
      items: [
        { included: Included.Yes },
        {
          included: Included.Yes,
        },
      ],
    },
    {
      label:
        'Towing and storage costs (insured events & damage caused by uninsured drivers)',
      items: [{ included: Included.No }, { included: Included.Yes }],
    },
    {
      label: 'Change of car (updating policy)',
      items: [{ included: Included.Yes }, { included: Included.Yes }],
    },
  ],
};
